<!-- <template>
	<div class="s-gray-bg p-font0-6" style="min-height:100vh;padding-top: 1rem;">
		<div class="p-margin20 p-padding10  p-white-bg p-radius20 p-black " style="width: auto; padding-top: 0.5rem; padding-bottom: 0.5rem;"  @click="goToNibpIndexVideo()">
		
			<div class="p-box-center">
				<img class="p-center" src="@/assets/img/guide_device_connect.png"  style="width: 22rem; padding-top: 0.5rem; padding-bottom: 0.5rem;"/>
			</div>
			<div style="height:0.5rem;"> </div>
			<div class="p-box p-inline-block p-width100">
				<span style="float:left">
					<span class="p-line-hegith1-4 p-font1-2  p-margin10 p-bold" >配对连接</span>
					<br/>
					<br/>
					<span class="p-line-hegith1-4 p-font0-8 p-margin10  p-normal ">鸿蒙系统或安卓系统手机配对连接</span>
				</span>
				<span style="float:right"><img class="p-margin10" src="@/assets/img/guide_device_right_arrow.png" style="width: 2rem; padding-top: 0.5rem; padding-bottom: 0.5rem;"/></span>	
			</div>
			<div style="height:0.5rem;"> </div>
		</div>

		<div style="height:1rem;"> </div>

		<div class="p-margin20  p-padding10  p-white-bg p-radius20 p-black " style="width: auto; padding-top: 0.5rem; padding-bottom: 0.5rem;"  @click="goToUseHelpVideo()">
			<div class="p-box-center">
				<img class="p-center" src="@/assets/img/guide_device_use_help.png"  style="width: 22rem; padding-top: 0.5rem; padding-bottom: 0.5rem;"/>
			</div>
			<div style="height:0.5rem;"> </div>
			<div class="p-box p-inline-block p-width100">
				<span style="float:left">
					<span class="p-line-hegith1-4 p-font1-2  p-margin10 p-bold" >佩戴与血压测量</span>
					<br/>
					<br/>
					<span class="p-line-hegith1-4 p-font0-8 p-margin10 p-padding-top20 p-normal ">快速了解手表使用，开启血压测量</span>
				</span>
				<span style="float:right"><img class="p-margin10" src="@/assets/img/guide_device_right_arrow.png" style="width: 2rem; padding-top: 0.5rem; padding-bottom: 0.5rem;"/></span>	
			</div>
			<div style="height:0.5rem;"> </div>
		</div>
	</div>
</template> -->
<template>
	<div class="s-gray-bg p-font0-6" style="min-height:100vh;padding-top: 1rem;">
		<div class="p-margin20 p-padding10  p-white-bg p-radius20 p-black " style="width: auto; padding-top: 0.5rem; padding-bottom: 0.5rem;"  @click="goToNibpIndexVideo()">
		
			<div class="p-box-center">
				<img class="p-center" src="@/assets/img/guide_device_connect.png"  style="width: 22rem; padding-top: 0.5rem; padding-bottom: 0.5rem;"/>
			</div>
			<div style="height:0.5rem;"> </div>
			<div class="p-box p-inline-block p-width100">
				<span style="float:left">
					<span class="p-line-hegith1-4 p-font1-2  p-margin10 p-bold" >{{ $t('measure.suanHuaGuideTip1') }}</span>
					<br/>
					<br/>
					<span class="p-line-hegith1-4 p-font0-8 p-margin10  p-normal ">{{ $t('measure.suanHuaGuideTip5') }}</span>
				</span>
				<span style="float:right"><img class="p-margin10" src="@/assets/img/guide_device_right_arrow.png" style="width: 2rem; padding-top: 0.5rem; padding-bottom: 0.5rem;"/></span>	
			</div>
			<div style="height:0.5rem;"> </div>
		</div>

		<div style="height:1rem;"> </div>

		<div class="p-margin20  p-padding10  p-white-bg p-radius20 p-black " style="width: auto; padding-top: 0.5rem; padding-bottom: 0.5rem;"  @click="goToUseHelpVideo()">
			<div class="p-box-center">
				<img class="p-center" src="@/assets/img/guide_device_use_help.png"  style="width: 22rem; padding-top: 0.5rem; padding-bottom: 0.5rem;"/>
			</div>
			<div style="height:0.5rem;"> </div>
			<div class="p-box p-inline-block p-width100">
				<span style="float:left">
					<span class="p-line-hegith1-4 p-font1-2  p-margin10 p-bold" >{{ $t('measure.suanHuaGuideTip3') }}</span>
					<br/>
					<br/>
					<span class="p-line-hegith1-4 p-font0-8 p-margin10 p-padding-top20 p-normal ">{{ $t('measure.suanHuaGuideTip4') }}</span>
				</span>
				<span style="float:right"><img class="p-margin10" src="@/assets/img/guide_device_right_arrow.png" style="width: 2rem; padding-top: 0.5rem; padding-bottom: 0.5rem;"/></span>	
			</div>
			<div style="height:0.5rem;"> </div>
		</div>

		<div style="height:1rem;"> </div>

		<div class="p-margin20  p-padding10  p-white-bg p-radius20 p-black " style="width: auto; padding-top: 0.5rem; padding-bottom: 0.5rem;"  @click="goToUseBiaoPanVideo()">
			<div class="p-box-center">
				<img class="p-center" src="@/assets/img/guide_device_use_help.png"  style="width: 22rem; padding-top: 0.5rem; padding-bottom: 0.5rem;"/>
			</div>
			<div style="height:0.5rem;"> </div>
			<div class="p-box p-inline-block p-width100">
				<span style="float:left">
					<span class="p-line-hegith1-4 p-font1-2  p-margin10 p-bold" >{{ $t('measure.suanHuaGuideTip6') }}</span>
					<br/>
					<br/>
					<span class="p-line-hegith1-4 p-font0-8 p-margin10 p-padding-top20 p-normal ">{{ $t('measure.suanHuaGuideTip7') }}</span>
				</span>
				<span style="float:right"><img class="p-margin10" src="@/assets/img/guide_device_right_arrow.png" style="width: 2rem; padding-top: 0.5rem; padding-bottom: 0.5rem;"/></span>	
			</div>
			<div style="height:0.5rem;"> </div>
		</div>
	</div>
</template>
<script>
	import mixins from '@/utils/mixins.js'
	import {
		mapState
	} from 'vuex'
	export default {
		name: "userAgreement",
		mixins: [mixins],
		components: {

		},
		data() {
			return {
				title: '',
			}
		},
		methods: {
			goToNibpIndexVideo(){
				console.log('goToNibpIndexVideo')
				// this.$router.push({
				//     path: '/guide/video',
				//     query: {
				// 	  title:'配对连接',
				// 	  videoType:1,
				//     }
				//   })
				this.$router.push({
				    path: '/guide/video',
				    query: {
					  title:'如何进行血压的学习和测量',
					  videoType:3,
				    }
				  })
			},
			goToUseHelpVideo(){
				console.log('goToUseHelpVideo')
				// this.$router.push({
				//     path: '/guide/video',
				//     query: {
				// 	  title:'佩戴与血压测量',
				// 	  videoType:2,
				//     }
				//   })
				this.$router.push({
				    path: '/guide/video',
				    query: {
					  title:'如何进行血压的学习',
					  videoType:4,
				    }
				  })
			},
			goToUseBiaoPanVideo(){
				console.log('goToUseBiaoPanVideo')
				this.$router.push({
				    path: '/guide/video',
				    query: {
					  title:'如何通过APP换表盘',
					  videoType:5,
				    }
				  })
			},
		},
		created() {
			document.title = '心波健康手表操作指导视频';
			var link = document.querySelector('link[rel*="icon"]')
			link.href = "bitbug_favicon.ico"	
		},
	}
</script>

<style scoped>

</style>
